export default "__VITE_ASSET__BdW_Zyio__"